import { render, staticRenderFns } from "./riskAnalysisTeam.vue?vue&type=template&id=059e2b2e"
import script from "./riskAnalysisTeam.vue?vue&type=script&lang=js"
export * from "./riskAnalysisTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059e2b2e')) {
      api.createRecord('059e2b2e', component.options)
    } else {
      api.reload('059e2b2e', component.options)
    }
    module.hot.accept("./riskAnalysisTeam.vue?vue&type=template&id=059e2b2e", function () {
      api.rerender('059e2b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/plan/riskAnalysisTeam.vue"
export default component.exports